if (typeof ProductPage !== "function") {
  class ProductPage extends HTMLElement {
    constructor() {
      super();

      this.productGallery = this.querySelector("[data-js-product-gallery]");
      this.productSlider = this.querySelector("css-slider");

      // Track if we're initializing to prevent unwanted change events
      this._isInitializing = true;

      // Check if there are YouTube embeds in the gallery
      this._hasYouTubeEmbeds =
        this.querySelector(".youtube-consent-embed") !== null;

      // If YouTube embeds are present, block slider auto-detection IMMEDIATELY
      // This must happen before the slider initializes to prevent IntersectionObserver from firing
      if (this.productSlider && this._hasYouTubeEmbeds) {
        this.productSlider._sliderBlockScroll = true;
      }

      // Gallery thumbnails

      if (this.productSlider) {
        const productGaleryThumbnails = this.querySelector(
          ".product-gallery__thumbnails-holder"
        );

        if (this.querySelector(".product-gallery__thumbnails .thumbnail")) {
          this.querySelectorAll(
            ".product-gallery__thumbnails .thumbnail"
          ).forEach((elm, i) => {
            if (i == 0) {
              elm.classList.add("active");
            }
            elm.addEventListener("click", (e) => {
              if (this.productSlider.sliderEnabled) {
                this.productSlider.changeSlide(e.currentTarget.dataset.index);
              } else {
                window.scrollTo({
                  top:
                    this.productGallery.querySelector(
                      `.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`
                    ).offsetTop + this.offsetTop,
                  behavior: "smooth",
                });
                this.thumbnailNavigationHelper(e.currentTarget.dataset.index);
              }
              productGaleryThumbnails.scrollTo({
                left: elm.offsetLeft - 50,
                behaviour: "smooth",
              });
            });
          });

          this.productSlider.addEventListener("change", (e) => {
            this.thumbnailNavigationHelper(e.target.index);
          });
        }

        this.productSlider.addEventListener("change", (e) => {
          // Ignore change events during initialization to prevent auto-scroll
          if (this._isInitializing) {
            return;
          }

          if (
            this.productGallery.querySelector(
              `.product-gallery-item[data-index="${e.target.index}"]`
            ).dataset.productMediaType == "model"
          ) {
            if (this.xrButton) {
              this.xrButton.setAttribute(
                "data-shopify-model3d-id",
                this.productGallery.querySelector(
                  `.product-gallery-item[data-index="${e.target.index}"]`
                ).dataset.mediaId
              );
            }
            setTimeout(() => {
              this.productSlider
                .querySelector(".css-slider-holder")
                .classList.add("css-slider--disable-dragging");
            }, 150);
          }
        });

        // Parallax

        this.productSlider.addEventListener("ready", (e) => {
          // Clear ALL transforms initially to prevent incorrect values
          this.querySelectorAll(".apply-gallery-animation").forEach((media) => {
            media.style.transform = "";
          });

          // Block slider auto-detection during initialization to prevent unwanted scrolling
          this.productSlider._sliderBlockScroll = true;

          // If YouTube embeds are present, disconnect IntersectionObserver IMMEDIATELY
          // to prevent it from detecting the wrong slide after YouTube embeds load
          if (this._hasYouTubeEmbeds && this.productSlider.OBSERVER) {
            this.productSlider.OBSERVER.disconnect();
          }

          // Force slider to start at position 0 to prevent auto-scroll
          // Wait a bit for layout to settle, especially if YouTube embeds are loading
          // Use requestAnimationFrame to ensure DOM is ready
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              // Force scroll to 0 first
              this.productSlider.element.scrollLeft = 0;
              this.productSlider.element.scrollTo({
                left: 0,
                top: 0,
                behavior: "auto",
              });

              // Reset slider index to 0
              if (this.productSlider.index !== 0) {
                this.productSlider.index = 0;
                this.productSlider.checkSlide();
              }

              // Wait for YouTube embeds to finish loading before allowing auto-detection
              // Use longer delay for YouTube embeds to ensure they're fully loaded
              const delay = this._hasYouTubeEmbeds ? 500 : 300;
              setTimeout(() => {
                // Force scroll to 0 one more time after delay (in case YouTube embeds shifted layout)
                if (this._hasYouTubeEmbeds) {
                  this.productSlider.element.scrollLeft = 0;
                  // Also reset index to 0 if it changed
                  if (this.productSlider.index !== 0) {
                    this.productSlider.index = 0;
                    this.productSlider.checkSlide();
                  }
                }

                // Only change slide if explicitly requested AND it's not 0
                if (
                  this.firstProductGalleryIndex !== undefined &&
                  this.firstProductGalleryIndex !== null &&
                  this.firstProductGalleryIndex !== 0
                ) {
                  this.productSlider.changeSlide(
                    this.firstProductGalleryIndex,
                    "auto"
                  );
                }

                // Re-enable slider auto-detection after everything is settled
                setTimeout(() => {
                  this.productSlider._sliderBlockScroll = false;
                  this._isInitializing = false;

                  // Reconnect IntersectionObserver if YouTube embeds were present
                  if (
                    this._hasYouTubeEmbeds &&
                    this.productSlider.OBSERVER &&
                    this.productSlider.indexedItems &&
                    this.productSlider.indexedItems.length > 0
                  ) {
                    this.productSlider.indexedItems.forEach((item) => {
                      this.productSlider.OBSERVER.observe(item);
                    });
                  }
                }, 100);
              }, delay);
            });
          });

          const productSlides = this.productSlider.querySelectorAll(
            ".product-gallery-item"
          );

          // Prevent unwanted scrolling during initialization (especially for YouTube embeds)
          // NOTE: This only prevents scroll events, not clicks
          if (this._hasYouTubeEmbeds) {
            const preventScrollDuringInit = (e) => {
              // Only prevent scroll, not clicks - check event type
              if (
                e.type === "scroll" &&
                this._isInitializing &&
                this.productSlider.element.scrollLeft !== 0
              ) {
                this.productSlider.element.scrollLeft = 0;
              }
            };
            this.productSlider.element.addEventListener(
              "scroll",
              preventScrollDuringInit,
              { passive: true }
            );
            // Remove listener after initialization
            setTimeout(() => {
              this.productSlider.element.removeEventListener(
                "scroll",
                preventScrollDuringInit
              );
            }, 600);
          }

          this.productSlider.addEventListener("scroll", () => {
            const scrollX = -this.productSlider.element.scrollLeft;

            // Iterate through each slide and find its figure directly
            productSlides.forEach((slide) => {
              // Check if this slide contains a YouTube embed
              const hasYouTube = slide.querySelector(".youtube-consent-embed");

              if (!hasYouTube) {
                // Find the figure within this slide that should have parallax
                const figure = slide.querySelector(".apply-gallery-animation");
                if (
                  figure &&
                  !figure.classList.contains("youtube-consent-embed") &&
                  !figure.closest(".youtube-consent-embed")
                ) {
                  // Apply parallax transform to this figure
                  // Use offsetLeft directly (it's relative to the css-slider-container parent)
                  figure.style.transform = `translateX(${
                    ((slide.offsetLeft + scrollX) * -1) / 3
                  }px)`;
                }
              } else {
                // Clear transforms on YouTube embeds and their children
                const youtubeEmbed = slide.querySelector(
                  ".youtube-consent-embed"
                );
                if (youtubeEmbed) {
                  youtubeEmbed.style.transform = "";
                  youtubeEmbed
                    .querySelectorAll(".apply-gallery-animation")
                    .forEach((child) => {
                      child.style.transform = "";
                    });
                }
              }
            });
          });

          // Also clear transforms on initial scroll event to ensure clean state
          setTimeout(() => {
            this.productSlider.dispatchEvent(new Event("scroll"));
          }, 200);
        });
      }

      // show cart drawer when element is added to cart

      if (
        !document.body.classList.contains("template-cart") &&
        (KROWN.settings.cart_action == "overlay" ||
          KROWN.settings.cart_action == "popup")
      ) {
        let addToCartEnter = false;
        if (this.querySelector("[data-js-product-add-to-cart]")) {
          this.querySelector("[data-js-product-add-to-cart]").addEventListener(
            "keyup",
            (e) => {
              if (e.keyCode == window.KEYCODES.RETURN) {
                addToCartEnter = true;
                window.lastFocusedElm = this.querySelector(
                  "[data-js-product-add-to-cart]"
                );
              }
            }
          );
        }

        if (this.querySelector("[data-js-product-form]")) {
          this.querySelector("[data-js-product-form]").addEventListener(
            "add-to-cart",
            () => {
              document.getElementById("site-cart-sidebar").show();
              if (document.getElementById("cart-recommendations")) {
                document
                  .getElementById("cart-recommendations")
                  .generateRecommendations();
              }
              if (addToCartEnter) {
                setTimeout(() => {
                  document
                    .querySelector("#site-cart-sidebar [data-js-close]")
                    .focus();
                  addToCartEnter = false;
                }, 200);
              }
            }
          );
        }
      }

      // Check for models

      const models = this.querySelectorAll("product-model");
      if (models.length > 0) {
        window.ProductModel.loadShopifyXR();
        this.xrButton = this.querySelector(".product-gallery__view-in-space");
      }

      // hide buy now button if stock disabled

      const addToCartButton = this.querySelector(
        "[data-js-product-add-to-cart]"
      );
      if (addToCartButton) {
        if (addToCartButton.classList.contains("disabled")) {
          this.querySelector("product-form").classList.add(
            "disable-buy-button"
          );
        } else {
          this.querySelector("product-form").classList.remove(
            "disable-buy-button"
          );
        }
        const buyObserver = new MutationObserver(() => {
          if (addToCartButton.classList.contains("disabled")) {
            this.querySelector("product-form").classList.add(
              "disable-buy-button"
            );
          } else {
            this.querySelector("product-form").classList.remove(
              "disable-buy-button"
            );
          }
        });
        buyObserver.observe(addToCartButton, {
          attributes: true,
          childList: false,
          subtree: false,
        });
      }

      // Product variant event listener for theme specific logic

      this.productVariants = this.querySelector(
        "product-variants[data-main-product-variants]"
      );
      if (this.productVariants) {
        this.productVariants.addEventListener(
          "VARIANT_CHANGE",
          this.onVariantChangeHandler.bind(this)
        );
        /* Kein initialer Gallery-Sprung: verhindert Wechsel weg vom ersten Medien-Slide beim Laden
           (z. B. wenn featured_media der Variante nicht media[0] ist). Echte VARIANT_CHANGE-Events
           vom Nutzer synchronisieren die Galerie weiterhin. */
      }
    }

    thumbnailNavigationHelper(index = 0) {
      this.querySelectorAll(".product-gallery__thumbnails .thumbnail").forEach(
        (elm, i) => {
          if (i == index) elm.classList.add("active");
          else elm.classList.remove("active");
        }
      );
    }

    onVariantChangeHandler(e) {
      let variant = e.target.currentVariant;
      if (variant) {
        // image handling

        if (variant.featured_media != null) {
          let variantImg = this.productGallery.querySelector(
            '.product-gallery-item[data-media-id="' +
              variant.featured_media.id +
              '"]'
          );
          if (variantImg) {
            if (
              this.productGallery.classList.contains(
                "product-gallery--slider"
              ) ||
              (this.productGallery.classList.contains(
                "product-gallery--scroll"
              ) &&
                window.innerWidth < 1024)
            ) {
              if (
                this.productGallery.querySelector("css-slider") &&
                this.productGallery.querySelector("css-slider").sliderEnabled
              ) {
                this.productGallery
                  .querySelector("css-slider")
                  .changeSlide(variantImg.dataset.index);
              } else {
                this.firstProductGalleryIndex = variantImg.dataset.index;
              }
            } else {
              window.scrollTo({
                top: variantImg.offsetTop,
                behavior: "smooth",
              });
            }
          }
        }
      }
    }
  }

  if (typeof customElements.get("product-page") == "undefined") {
    customElements.define("product-page", ProductPage);
  }
}
